// extracted by mini-css-extract-plugin
export default {"resetPasswordContainer":"index_resetPasswordContainer__23Q5e"};